import React, { Component } from "react";
import { CollapseHeader, CollapseContent } from "./";
import { withGetScreen } from "react-getscreen";

class Collapse extends Component {
	constructor(props) {
		super(props);

		this.state = {
			collapseHandler: false
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
		e.preventDefault();

		this.setState({
			collapseHandler: !this.state.collapseHandler
		});
	}

	render() {
		const { collapseHandler } = this.state; //state
		const {
			className,
			headerIcon,
			headerTitle,
			content,
			headerchildren,
			arrowPrimaryColor,
			isMobile,
			isTablet,
			isDesktop,
			...props
		} = this.props; // props
		const style = ["collapse-component", !!className ? className : ""].join(" ");

		return (
			<div className={style} {...props}>
				<CollapseHeader onClick={e => this.handleChange(e)}>
					{!!headerchildren ? (
						headerchildren
					) : (
						<div>
							<i className={headerIcon} />
							{headerTitle}
						</div>
					)}
					<div>
						<i
							className={`icon-arrow-down${collapseHandler ? " rotate-in-out" : ""}${
								arrowPrimaryColor ? " collapse-component--arrow-primary-color" : ""
							}`}
						/>
					</div>
				</CollapseHeader>
				<CollapseContent>
					{isMobile() ? (
						collapseHandler ? (
							//Atribuido dessa maneira para não causar erro na webview
							<div className="collapse-in-out-mobile slide-in-out-mobile">{content}</div>
						) : (
							<div className="collapse-in-out-mobile">{content}</div>
						)
					) : (
						<div className={`collapse-in-out ${collapseHandler ? "slide-in-out" : ""}`}>
							{content}
						</div>
					)}
				</CollapseContent>
			</div>
		);
	}
}

export default withGetScreen(Collapse, {
	mobileLimit: 468,
	tabletLimit: 768,
	shouldListenOnResize: true
});
